import { Link } from "react-router-dom";
import { useStore, needOf } from "@/context/StoreContext";
import { fileUrl } from "@/lib/api";
import { brl } from "@/lib/fmt";
import { BottleStack } from "./Bits";

export default function ProductCard({ p, onAdd }) {
  const { meta, add } = useStore();
  const need = needOf(meta, p);
  const kit = p.forma === "kit";
  return (
    <article className="group flex flex-col overflow-hidden rounded-[28px] border border-na-line bg-white transition-[box-shadow,transform] duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-na-forest/5" data-testid={`product-card-${p.slug}`}>
      <Link to={`/produto/${p.slug}`} className="relative flex aspect-[4/3.4] items-center justify-center overflow-hidden" style={{ background: need.cor_fundo }}>
        {p.off > 0 && <span className="badge-off absolute left-4 top-4 z-10">-{p.off}%</span>}
        {kit ? <BottleStack images={p.imagens} count={p.imagens.length} size="h-36 sm:h-40" /> :
          <img src={fileUrl(p.imagens?.[0])} alt={p.nome} loading="lazy" className="prod-img h-[82%] w-auto object-contain transition-transform duration-500 group-hover:scale-105" />}
      </Link>
      <div className="flex flex-1 flex-col p-5">
        <p className="text-[11px] font-semibold uppercase tracking-wider" style={{ color: need.cor_texto }}>{need.nome}</p>
        <Link to={`/produto/${p.slug}`}><h3 className="mt-1 font-serif text-lg leading-snug text-na-ink">{p.nome}</h3></Link>
        {p.alegacoes?.[0] && <p className="mt-1 line-clamp-2 text-sm text-na-ink2">{p.alegacoes[0]}</p>}
        <div className="mt-auto pt-4">
          {p.preco_de > p.preco && <p className="text-xs text-na-ink2 line-through">{brl(p.preco_de)}</p>}
          <p className="text-lg font-bold text-na-ink" data-testid={`card-price-${p.slug}`}>{brl(p.preco)}</p>
          <p className="text-xs font-semibold text-na-forest">{brl(p.preco_pix)} no Pix</p>
          <button className="btn-na mt-3 w-full py-2.5" disabled={p.estoque <= 0} onClick={() => (onAdd ? onAdd(p) : add(p.slug, 1, 1, false, "drawer", p.preco))} data-testid={`add-to-cart-${p.slug}`}>
            {p.estoque <= 0 ? "Esgotado" : "Adicionar à sacola"}
          </button>
        </div>
      </div>
    </article>
  );
}
